const marketCustomSelect = document.querySelector('.market.customSelect');
const marketSelectButton = marketCustomSelect.querySelector('.selectButton');
const marketSelectedValue = marketCustomSelect.querySelector('.selectedValue');
const marketSelectRequiredInput = marketCustomSelect.querySelector('.selectRequiredInput');
const marketSelectDropdown = marketCustomSelect.querySelector('.selectDropdown');

marketSelectButton.addEventListener('click', () => {
  marketCustomSelect.classList.toggle('active');
  marketSelectButton.setAttribute(
    'aria-expanded',
    marketSelectButton.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
  );
});

function loadmarket() {
  const market = ['AE', 'TH'];
  const labels = {
    AE: i18next.t('content.joinForm.market.AE') || '🇦🇪 United Arab Emirates',
    TH: i18next.t('content.joinForm.market.TH') || '🇹🇭 Thailand'
  };
  marketSelectDropdown.innerHTML = '';
  market.forEach((country) => {
    marketSelectDropdown.innerHTML = `${marketSelectDropdown.innerHTML}
      <li role="option"><label id="${country}">${labels[country]}</label></li>
    `;
  });

  marketSelectDropdown.querySelectorAll('li').forEach((option) => {
    function handler(e) {
      if (e.type === 'click' && e.clientX !== 0 && e.clientY !== 0) {
        marketSelectedValue.textContent = this.children[0].textContent;
        marketSelectRequiredInput.value = this.children[0].id;
        marketCustomSelect.classList.remove('active');
      }
    }

    option.addEventListener('click', handler);
  });
}

document.addEventListener('DOMContentLoaded', loadmarket);
document.addEventListener('languageChanged', loadmarket);
